/* @flow */

const formatarCPF = (cpf: string) => {
    let cpfFormatado = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpfFormatado = cpfFormatado.replace(/(\d{3})(\d)/, '$1.$2');
    return cpfFormatado.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

export default formatarCPF;
